import React, { useState } from 'react';
import {
    Paper, Table, TableBody, TableCell, TableContainer, TableHead,
    TableRow, Checkbox, Button, Typography, Box, TablePagination,
    Container,
    CircularProgress
} from "@mui/material";
import { toast } from 'react-toastify';

export default function CollectedDataTable({ loading, collectedData, onDeleteRows }) {
    const dataArray = Object.entries(collectedData || {}).map(([key, value]) => ({
        id: key,
        ...value
    }));

    const sortedData = [...dataArray].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

    const [selectedRows, setSelectedRows] = useState([]);
    const [page, setPage] = useState(0);
    const rowsPerPage = 50;

    const [deleting, setDeleting] = useState(false);

    if (loading) return <p>loading...</p>;

    if (!sortedData || sortedData.length === 0) return <p>No data available</p>;

    const columns = Object.keys(sortedData[0])
        .filter(col => col !== 'id' && col !== 'timestamp');

    const handleSelectRow = (id) => {
        setSelectedRows((prev) =>
            prev.includes(id)
                ? prev.filter((item) => item !== id)
                : [...prev, id]
        );
    };
    

    const handleDeleteSelected = async () => {
        setDeleting(true);
        await onDeleteRows(selectedRows);
        setDeleting(false);
        toast.success(`${selectedRows.length} row(s) deleted`);
        setSelectedRows([]);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const paginatedRows = sortedData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <Container sx={{ marginY: 3, }}>
            {selectedRows.length > 0 && (
                <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Typography variant="subtitle1">
                        {selectedRows.length} selected
                    </Typography>
                    <Button variant="contained" color="error" onClick={handleDeleteSelected}>
                        {deleting ? <CircularProgress color='inherit'/> : 'Delete Selected'}
                    </Button>
                </Box>
            )}

            <Paper
                elevation={1}
                sx={{
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'grey.300',
                    overflow: 'hidden'
                }}
            >
            
            
                <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow sx={{ backgroundColor: 'grey.300' }}>
                                <TableCell padding="checkbox" />
                                {columns.map((col) => (
                                    <TableCell key={col} sx={{ fontWeight: 'bold' }}>
                                        {col.toUpperCase()}
                                    </TableCell>
                                ))}
                                <TableCell sx={{ fontWeight: 'bold' }}>SUBMITTED AT</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {paginatedRows.map((row) => (
                                <TableRow key={row.id} hover>
                                    <TableCell padding="checkbox">
                                        <Checkbox
                                            checked={selectedRows.includes(row.id)}
                                            onChange={() => handleSelectRow(row.id)}
                                        />
                                    </TableCell>
                                    {columns.map((col) => (
                                        <TableCell key={col}>
                                            {row[col] === 'null' || row[col] === null ? '—' : row[col]}
                                        </TableCell>
                                    ))}
                                    <TableCell>
                                        {row.timestamp
                                            ? new Date(row.timestamp).toLocaleString()
                                            : '—'}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

                <TablePagination
                    component="div"
                    count={sortedData.length}
                    page={page}
                    onPageChange={handleChangePage}
                    rowsPerPage={rowsPerPage}
                    rowsPerPageOptions={[rowsPerPage]} 
                />
            </Paper>
        </Container>
    );
}
